/**
 * @document ../CHANGELOG.md
 * @module
 */

export {createFeature} from "./service/create-feature.js";

export {defineCustomWidget} from "./service/widget.js";
export {digest} from "./service/digest.js";

export {defineResourceLoader} from "./service/lookup.js";
export {FeatureUtility} from "./model/utility/feature.js";
export {NamespaceUtility} from "./model/utility/namespace.js";
export {defineRenderElement, defineRenderAttribute, Rendering} from "./service/render.js";
export {
  defineElementSetup,
  defineAttributeSetup,
  defineElementSetup as defineRegistryElement,
  defineAttributeSetup as defineRegistryAttribute,
} from "./service/setup.js";
export {defineCompileElement, defineCompileAttribute} from "./service/compile.js";
export {Widget} from "./model/widget.js";

export {rootUtility as stargazer} from "./config/root-utility.js";

export {defineScope} from "./service/render.js";
export {NODES} from "./service/typeguard.js";

import {defineRenderAttribute} from "./service/render.js";

/**
 * @deprecated Use `defineRenderAttribute`
 * @param {string} name
 * @param {import("./service/types").RenderAttrFn} fn
 */
export function defineController(name, fn) {
  defineRenderAttribute(name, fn);
}
